import { Box, HStack, Text } from "@chakra-ui/react";
import { keyframes } from "@emotion/react";
import { useGovernedMotion } from "components/ds/frameGovernor";

const shimmer = keyframes`
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(300%);
  }
`;

interface LunaThinkingIndicatorProps {
  text?: string;
}

export const LunaThinkingIndicator = ({
  text = "Thinking...",
}: LunaThinkingIndicatorProps) => {
  /* the shimmer free-runs while Luna thinks — govern it (smooth tier: a
     1.5s sweep reads as stutter at the base rate) */
  const rootRef = useGovernedMotion<HTMLDivElement>(true);
  return (
    <Box
      ref={rootRef}
      position="relative"
      overflow="hidden"
      borderRadius="component.md"
      py="sm"
    >
      <HStack spacing="2xs" align="center">
        <Text
          fontSize="xs"
          fontWeight="medium"
          color="text.body.tertiary"
          lineHeight={1}
        >
          {text}
        </Text>
      </HStack>

      {/* Shimmer overlay */}
      <Box
        position="absolute"
        top={0}
        left={0}
        right={0}
        bottom={0}
        overflow="hidden"
        pointerEvents="none"
      >
        <Box
          position="absolute"
          top="50%"
          transform="translateY(-50%)"
          w="20px"
          h="25px"
          bg="white"
          filter="blur(6px)"
          opacity={0.7}
          animation={`${shimmer} 1.5s ease-in-out infinite`}
          sx={{
            /* without its animation the highlight would sit as a static
               blob — and the governor skips reduced-motion, so it must not
               free-run here either */
            "@media (prefers-reduced-motion: reduce)": { display: "none" },
          }}
        />
      </Box>
    </Box>
  );
};
